import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { ServiceListStateData } from './types';

const initialState: ServiceListStateData = {
	data: {
		data: [],
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchServiceList = createAsyncThunk('api/fetchUslugasList', (action: string) =>
	api.fetchServiceList(action),
);

const serviceListSlice = createSlice({
	name: 'uslugasList',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchServiceList.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchServiceList.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || [];
				state.error = '';
			})
			.addCase(fetchServiceList.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export default serviceListSlice.reducer;
